import { SinSidebarLayout } from 'layouts/SinSidebarLayout';
import { Cuerpo } from './components/Cuerpo';
import { SkeletonConcederAdministracion } from './components/SkeletonConcederAdministracion';
import { MensajeSolicitudRechazada } from './components/MensajeSolicitudRechazada';
import { MensajeSolicitudAprobada } from './components/MensajeSolicitudAprobada';
import { MensajeDatosInsuficientes } from './components/MensajeDatosInsuficientes';
import { useConfirmarRegistroAdministracion } from './hooks/useConfirmarRegistroAdministracion';
import { Form, Formik } from 'formik';
import { ConfirmarRegistroAdministracionSchema } from './utils/ConfirmarRegistroAdministracionSchema';
import { RegistroUsuario } from './components/RegistroUsuario';
import { TerminosYCondiciones } from './components/TerminosYCondiciones';

export const ConfirmarRegistroAdministracion = () => {
  const {
    ESTADOS,
    data,
    ingresandoDatosUsuario,
    isSubmiting,
    terminosAceptados,
    token,
    vista,
    setVista,
    setTerminosAceptados,
    setIngresandoDatosUsuario,
    autoRegistro,
    onRechazarSolicitud
  } = useConfirmarRegistroAdministracion();

  if (vista === ESTADOS.LOADING) {
    return <SkeletonConcederAdministracion />;
  }

  if (vista === ESTADOS.ERROR_INICIAL) {
    return <MensajeDatosInsuficientes />;
  }

  if (vista === ESTADOS.SOLICITUD_RECHAZADA) {
    return <MensajeSolicitudRechazada />;
  }

  if (vista === ESTADOS.SOLICITUD_APROBADA) {
    return <MensajeSolicitudAprobada />;
  }

  return (
    <SinSidebarLayout containerClassName="xs:px-4 md:container md:mx-auto">
      <Cuerpo data={data}>
        <Formik
          initialValues={{
            name: '',
            email: data.correoElectronicoInvitado,
            password1: '',
            password2: '',
            emailModificado: false,
            accion: '',
            token: token
          }}
          validateOnMount={true}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={(values, { resetForm, setTouched, setSubmitting }) => {
            const accion = values.accion;

            const userName = values.name.split(' ');
            let nombreUsuario = '';
            let apellidoPaterno = '';
            let apellidoMaterno = '';

            if (userName.length > 3) {
              nombreUsuario = userName[0] + ' ' + userName[1];
              apellidoPaterno = userName[2];
              apellidoMaterno = userName[3];
            } else {
              nombreUsuario = userName[0];
              apellidoPaterno = userName[1];
              apellidoMaterno = userName[2];
            }

            const formatRequest = {
              correoElectronico: values.email,
              nombreUsuario: nombreUsuario,
              apellidoPaterno: apellidoPaterno,
              apellidoMaterno: apellidoMaterno,
              token: values.token,
              accion: values.accion,
              password: values.password1
            };

            // console.log('formatRequest', formatRequest);

            if (accion === 'aceptar') {
              // Validar que todos los campos estén presentes
              if (
                !formatRequest.correoElectronico ||
                !formatRequest.nombreUsuario ||
                !formatRequest.apellidoPaterno ||
                !formatRequest.apellidoMaterno ||
                !formatRequest.token
              ) {
                throw new Error(
                  'Todos los campos son obligatorios cuando la acción es "aceptar".'
                );
              }
              // Llamar a la función de autoregistro
              autoRegistro(formatRequest);
            } else if (accion === 'rechazar') {
              // Los campos son opcionales, llamar a la función de autoregistro
              autoRegistro(formatRequest);
            } else {
              console.log('accion', accion);
              throw new Error('Acción no válida.');
            }

            // Restablecer el estado de "touched" después de enviar
            setTouched({});
            setSubmitting(false);

            // Opcional: Restablecer los valores del formulario
            resetForm();
          }}
          validationSchema={
            terminosAceptados
              ? ConfirmarRegistroAdministracionSchema
              : ingresandoDatosUsuario
              ? ConfirmarRegistroAdministracionSchema
              : null
          }
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            setFieldValue,
            setFieldTouched,
            validateForm,
            resetForm,
            handleSubmit,
            setSubmitting,
            setTouched,
            setErrors,
            initialValues,
            isSubmitting
          }) => {
            return (
              <Form
                id="confirmarRegistroAdministracion"
                onChange={() => {
                  // console.log('values', values)
                  // console.log('errors', errors)
                }}
              >
                {vista === ESTADOS.PRE_CONFIRMACION && (
                  <TerminosYCondiciones
                    touched={touched}
                    terminosAceptados={terminosAceptados}
                    setTerminosAceptados={setTerminosAceptados}
                    onVolver={() => setVista(ESTADOS.SOLICITUD_RECHAZADA)}
                    onContinuar={() => setVista(ESTADOS.REGISTRO_USUARIO)}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    isSubmiting={isSubmiting}
                    resetForm={resetForm}
                    onRechazarSolicitud={onRechazarSolicitud}
                    setVista={setVista}
                  />
                )}

                {vista === ESTADOS.REGISTRO_USUARIO && (
                  <RegistroUsuario
                    errors={errors}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    ingresandoDatosUsuario={ingresandoDatosUsuario}
                    initialValues={initialValues}
                    isSubmiting={isSubmiting}
                    isSubmitting={isSubmitting}
                    onVolver={() => setVista(ESTADOS.PRE_CONFIRMACION)}
                    resetForm={resetForm}
                    setFieldTouched={setFieldTouched}
                    setFieldValue={setFieldValue}
                    setIngresandoDatosUsuario={setIngresandoDatosUsuario}
                    terminosAceptados={terminosAceptados}
                    touched={touched}
                    validateForm={validateForm}
                    values={values}
                    setTouched={setTouched}
                    setSubmitting={setSubmitting}
                    setErrors={setErrors}
                  />
                )}
              </Form>
            );
          }}
        </Formik>
      </Cuerpo>
    </SinSidebarLayout>
  );
};
